<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="closeTax()"
  />
</div>
<form [formGroup]="TaxForm">
  <!-- -------- Tax Edit -------- -->
  <div>
    <div class="accordion-class">
      <h5>Edit Tax</h5>
      <mat-divider></mat-divider>
    </div>
    <div class="input-fileds-container">
      <div class="group driver-truck">
        <div class="row mtb">
          <div class="col-md-6">
            <mat-form-field>
              <mat-label>Tax Name:</mat-label>
              <input matInput formControlName="tax_name" required />
              <mat-error>Please Enter Tax Name</mat-error>
            </mat-form-field>
          </div>

          <!-- HSN Code for customerGST -->
          <div class="col-md-6" *ngIf="data?.tax_user_type === 'customerGST'">
            <mat-form-field>
              <mat-label>HSN Code:</mat-label>
              <input matInput formControlName="hsn_code" required />
              <mat-error>Please Enter HSN Code</mat-error>
            </mat-form-field>
          </div>
        </div>

        <!-- Tax Deduction for normal users only -->
        <div class="row mtb" *ngIf="data?.tax_user_type !== 'customerGST'">
          <div class="col-md-6">
            <mat-form-field>
              <mat-label>Tax Deduction:</mat-label>
              <input
                matInput
                appTwoDigitDecimaNumber
                formControlName="tax_deduction"
                required
              />
              <mat-error>Please Enter Tax Deduction</mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6 mt-1">
            <mat-form-field>
              <mat-select
                dropLocationSearchField
                formControlName="tax_type"
                placeholder="Tax Type"
                (selectionChange)="getTaxtype($event)"
                required
              >
                <mat-option value="percent">PERCENT</mat-option>
                <mat-option value="amount">AMOUNT</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <!-- RCM and FCM for customerGST -->
        <div class="row mtb" *ngIf="data?.tax_user_type === 'customerGST'">
          <div class="col-md-6">
            <mat-form-field>
              <mat-label>RCM Deduction (%):</mat-label>
              <input
                matInput
                formControlName="rcm_deduction"
                appTwoDigitDecimaNumber
                required
              />
              <mat-error>Please Enter RCM Deduction</mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field>
              <mat-label>FCM Deduction (%):</mat-label>
              <input
                matInput
                formControlName="fcm_deduction"
                appTwoDigitDecimaNumber
                required
              />
              <mat-error>Please Enter FCM Deduction</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row mtb">
          <mat-form-field>
            <mat-label>Comments</mat-label>
            <input matInput formControlName="tax_description" required />
            <mat-error>Please Enter Comments</mat-error>
          </mat-form-field>
        </div>
        
        <div class="row mtb" *ngIf="data?.tax_user_type === 'customerGST'" style="padding: 0 15px;">
          <div style="width: 100%;">
            <label style="font-size: 12px; color: rgba(0, 0, 0, 0.6); display: block; margin-bottom: 4px;">Products</label>
            <span style="font-size: 16px; color: rgba(0, 0, 0, 0.87); display: block;">{{ data?.products?.join(', ') || 'N/A' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="pull-left w-100">
    <button
      type="submit"
      class="button buttonBlue mb-3"
      [class.spinner]="loading"
      [disabled]="loading"
      (click)="updateTax()"
    >
      Save
    </button>
  </div>
</form>
